// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as CompletedActions } from '../duck';
import Completed from '../components/Completed';
import type { RootState } from "../../../../index";

function mapStateToProps(state: RootState) {
  return {
    order: state.order.order,
    disbursementInfo: state.order.sale.completed.disbursementInfo,
    isFetchingDisbursement: state.order.sale.completed.isFetchingDisbursement,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(CompletedActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Completed)



// WEBPACK FOOTER //
// ./src/modules/order/Sale/completed/containers/CompletedContainer.jsx